import { render, staticRenderFns } from "./ScheduleSettings.vue?vue&type=template&id=85cae8c0&scoped=true&"
import script from "./ScheduleSettings.vue?vue&type=script&lang=ts&"
export * from "./ScheduleSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85cae8c0",
  null
  
)

export default component.exports